var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 23,
    viewBox: "0 0 16 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Location") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19698_101393)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00036 22.9931C7.30036 22.9931 6.67036 22.6331 6.31036 22.0231L1.34036 13.6431C0.290358 12.0131 -0.159642 10.1131 0.0503579 8.23309C0.260358 6.32309 1.14036 4.53309 2.52036 3.21309C4.12036 1.66309 6.29036 0.853089 8.52036 1.01309C12.6204 1.30309 15.8304 4.67309 16.0004 8.83309C16.0604 10.6031 15.5804 12.2931 14.6004 13.7331L9.69036 22.0331C9.52036 22.3131 9.29036 22.5431 9.03036 22.7031C8.69036 22.9031 8.35036 22.9931 8.00036 22.9931ZM7.99036 2.99309C6.46036 2.99309 5.01036 3.58309 3.90036 4.65309C2.86036 5.65309 2.19036 7.00309 2.03036 8.45309C1.87036 9.90309 2.22036 11.3631 3.02036 12.5731C3.04036 12.6031 3.06036 12.6431 3.08036 12.6831L8.00036 20.9631L12.9004 12.6631C13.6704 11.5231 14.0404 10.2531 13.9904 8.91309C13.8704 5.77309 11.4504 3.23309 8.37036 3.01309C8.24036 3.01309 8.11036 3.00309 7.99036 3.00309V2.99309Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 11.9932C6.35 11.9932 5 10.6432 5 8.99316C5 7.34316 6.35 5.99316 8 5.99316C9.65 5.99316 11 7.34316 11 8.99316C11 10.6432 9.65 11.9932 8 11.9932ZM8 7.99316C7.45 7.99316 7 8.44316 7 8.99316C7 9.54316 7.45 9.99316 8 9.99316C8.55 9.99316 9 9.54316 9 8.99316C9 8.44316 8.55 7.99316 8 7.99316Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19698_101393"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 22,
    transform: "translate(0 0.993164)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.c1510c21afe85b6ca627a201cfb050a3.svg";
export { ForwardRef as ReactComponent };